<template>
  <div class="exchange">
    <div class="header">
      <div class="word">优惠券兑换</div>
    </div>
    <div class="body">
      <div>
        <input
          class="card-input"
          v-model="code"
          placeholder="请输入卡号"
          @input="doInput"
        />
      </div>
      <button class="body-button" @click="doExchange">兑换</button>
    </div>
  </div>
</template>
<script>
import { userExchangeCoupon } from "../../../../api/user";
export default {
  name: "UserExchangeCoupon",
  components: {},
  props: {},
  data: function() {
    return {
      code: ""
    };
  },
  mounted: function() {},
  methods: {
    doInput(e) {
      console.log(e);
      console.log(this.code);
    },
    doExchange() {
      let that = this;
      userExchangeCoupon({ code: this.code })
        .then(res => {
          console.log(res);
          this.$dialog.toast({
            mes: "兑换成功",
            duration: 1000
          });
          setTimeout(() => {
            that.$router.replace("/user/user_coupon");
          }, 1000);
        })
        .catch(err => {
          console.log(err.msg);
          this.$dialog.error(err.msg);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.exchange {
  .header {
    padding: 40px 0;
    box-sizing: border-box;
    position: relative;
    background-image: url("https://www.atropin.cn/uploads/attach/2021/11/20211116/ce933725d7d4a93121cdd56a1d602004.png");
    z-index: -1;
    color: rgb(174, 130, 89);
    .word {
      position: absolute;
      left: 50%;
      top: 40%;
      transform: translateX(-50%) translateY(-50%);
    }
    .word::after {
      content: "";
      position: absolute;
      width: 30px;
      height: 1px;
      left: 0;
      top: 50%;
      transform: translateX(-100%) translateY(-50%);
      background-color: rgb(174, 130, 89);
    }
    .word::before {
      content: "";
      position: absolute;
      width: 30px;
      height: 1px;
      right: 0;
      top: 50%;
      transform: translateX(100%) translateY(-50%);
      background-color: rgb(174, 130, 89);
    }
  }
  .body {
    width: 90%;
    margin: 0 auto;
    padding: 20px;
    border-radius: 5px;
    margin-top: -20px;
    background-image: url("https://www.atropin.cn/uploads/attach/2021/11/20211116/3be42307deb66c6a7fae2556f7868025.png");
    background-size: 100% 100%;
    .card-input {
      padding: 10px;
      background-color: rgba(255, 255, 255, 0.5);
      width: 100%;
      box-sizing: border-box;
    }
    .body-button {
      margin-top: 20px;
      color: #fff;
      background-color: rgb(53, 56, 65);
      border-radius: 10px;
      padding: 10px 0;
      width: 100%;
      box-sizing: border-box;
    }
  }
}
</style>
